<mat-expansion-panel class="box-shadow border-radius-0" (afterExpand)="onExpand()">
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">badge</mat-icon>
      <span>KCM</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div *ngIf="kcm$ | async as kcm">
      <app-data-box headerTitle="Location" [isLoading]="kcm.isLoading && !kcm.response" class="mt-16">
        <div *ngIf="kcm.response && kcm.response.lines!.length > 0" class="data-box-content text-sm">
          <p *ngFor="let line of kcm.response.lines">
            <span *ngIf="line.label" class="font-bold accent-color" [innerHTML]="line.label + ': '"></span>
            <span [innerHTML]="line.description"></span>
          </p>
        </div>
        <div *ngIf="
            !kcm.isLoading &&
            (!kcm.response ||
              (kcm.response && kcm.response.lines?.length === 0))
          " class="data-box-content text-sm">
          <div class="text-center">
            No KCM or information unavailable
          </div>
        </div>
      </app-data-box>
      <app-data-box *ngIf="kcm.response?.mapUrl || kcm.isLoading" [isLoading]="kcm.isLoading && !kcm.response"
        headerTitle="Map" class="mt-24">
        @if (theme$ | async; as theme) {
        <div class="data-box-content">
          <img [class.dark-theme]="theme === 'dark'" [src]="kcm.response?.mapUrl" width="100%" alt="" />
        </div>
        }
      </app-data-box>
      <div class="data-status">
        <app-data-status [isLoading]="kcm.isLoading" [timestamp]="kcm.response?.timestamp"
          (refresh)="refresh()"></app-data-status>
      </div>
      <mat-progress-bar *ngIf="kcm.isLoading" class="progress-bar-bottom" color="accent"
        mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-template>
</mat-expansion-panel>